export default "__VITE_ASSET__BmrpJBpE__"